import React from "react";

interface PaginationInfoProps {
  totalRecords: number;
  currentPage: number;
  limit: number;
}

const PaginationInfo: React.FC<PaginationInfoProps> = ({
  totalRecords,
  currentPage,
  limit,
}) => {
  const startIndex = (currentPage - 1) * limit + 1;
  const endIndex = Math.min(currentPage * limit, totalRecords);

  return (
    <div className="text-sm text-muted-foreground">
      Showing {startIndex} to {endIndex} out of {totalRecords} Records
    </div>
  );
};

export default PaginationInfo;
